import "./DedicatedServiceAndLocationPages.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import ExteriorServicesOverview from "./sections/ExteriorServicesOverview";
import OurLocations from "./sections/OurLocations";
import DiscoverKyotoCta from "./sections/DiscoverKyotoCta";
import Footer from "@/reusable_sections/Footer";
export default function DedicatedServiceAndLocationPagesPage() {
  return <div>
      <Header />
      <Hero />
      <ExteriorServicesOverview />
      <OurLocations />
      <DiscoverKyotoCta />
      <Footer />
    </div>;
}